import {
  Box,
  TextField,
  InputAdornment,
  Button,
  Popover,
  MenuItem,
  Typography,
  Grid,
  Divider,
  LinearProgress,
  FormControl,
  Select,
  InputLabel,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import FormComponent from './Form';
import { useTranslation } from 'react-i18next';
import { numberFormat } from '../../utils/nunberFormat';
import AddIcon from '@mui/icons-material/Add';
import Pagination from '@mui/material/Pagination';
import { SELECT_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from '../../constants/colors';
import ALL_PRODUCT_STATISTIC from '../../assets/images/all_product_statistic.svg';
import { useCouponController } from './controller';
import ConfirmDialog from '../../components/ConfirmDialog';
import TabPanelCouponPage from './components/tabPanel';
import { CouponEnum } from '../../enums/couponEnum';
import { EN_ACCEPT_LANGUAGE } from '../../constants/acceptLanguageApi';
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated';
import TableAmount from './table/TableAmount';
import TablePercent from './table/TablePercent';
import TableDeliveryFee from './table/TableDeliveryFee';
import TableDeliveryFeeAmount from './table/TableDeliveryFeeAmount';
import TableDeliveryFeePercent from './table/TableDeliveryFeePercent';

const CouponView = () => {
  const { t, i18n } = useTranslation('global');
  const controller = useCouponController();

  const useRenderTable = () => {
    switch (controller.couponType) {
      case CouponEnum.AMOUNT:
        return (
          <TableAmount
            rows={controller.rows}
            currentPage={controller.currentPage}
            onOpenMenu={controller.handleOpenMenu}
            searchValue={controller.searchValue}
            isSearchNotFound={controller.isSearchNotFound}
          />
        );
      case CouponEnum.PERCENT:
        return (
          <TablePercent
            rows={controller.rows}
            currentPage={controller.currentPage}
            onOpenMenu={controller.handleOpenMenu}
            searchValue={controller.searchValue}
            isSearchNotFound={controller.isSearchNotFound}
          />
        );
      case CouponEnum.DELIVERY_FREE:
        return (
          <TableDeliveryFee
            rows={controller.rows}
            currentPage={controller.currentPage}
            onOpenMenu={controller.handleOpenMenu}
            searchValue={controller.searchValue}
            isSearchNotFound={controller.isSearchNotFound}
          />
        );
      case CouponEnum.DELIVERY_FEE_AMOUNT:
        return (
          <TableDeliveryFeeAmount
            rows={controller.rows}
            currentPage={controller.currentPage}
            onOpenMenu={controller.handleOpenMenu}
            searchValue={controller.searchValue}
            isSearchNotFound={controller.isSearchNotFound}
          />
        );
      case CouponEnum.DELIVERY_FEE_PERCENT:
        return (
          <TableDeliveryFeePercent
            rows={controller.rows}
            currentPage={controller.currentPage}
            onOpenMenu={controller.handleOpenMenu}
            searchValue={controller.searchValue}
            isSearchNotFound={controller.isSearchNotFound}
          />
        );
      default:
        break;
    }
  };
  const renderTable = useRenderTable();

  return (
    <Box>
      {controller.openForm ? (
        <FormComponent
          onClose={controller.handleCloseForm}
          onFetchData={controller.handleFetchData}
          couponData={controller.selectedCoupon}
          setCoupon={controller.setSelectedCoupon}
          branchValue={controller.branchValue}
          selectCouponType={controller.couponType}
          branchData={controller.branchData}
        />
      ) : (
        <Box>
          {controller.loadingMainData ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <LoadingAnimatedIcon />
            </Box>
          ) : (
            <>
              <Box mb={2} sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    gap: 2,
                    width: '100%',
                  }}
                >
                  <Typography color={TEXT_TITLE_COLOR} fontWeight="bold" fontSize={35}>
                    {t('coupon_page.Coupon management')}
                  </Typography>

                  <TextField
                    value={controller.searchValue}
                    onChange={controller.handleSearchValue}
                    fullWidth
                    sx={{ maxWidth: 250 }}
                    placeholder={`${t('coupon_page.Search by name')} ...`}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                    size="small"
                  />
                  <Box sx={{ width: 200 }}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="merchant-label-id">{t('coupon_page.Branch')}</InputLabel>
                      <Select
                        labelId="merchant-label-id"
                        id="merchant-id"
                        label="Merchant"
                        value={controller.branchValue}
                        onChange={(e) => controller.handleSelectedBranch(e)}
                        sx={{
                          bgcolor: SELECT_BACKGROUND_COLOR,
                          '.MuiOutlinedInput-notchedOutline': { border: 0 },
                          borderRadius: '8px',
                        }}
                      >
                        <MenuItem value="All"> {t('coupon_page.All Branch')} </MenuItem>
                        {controller.branchData?.map((branch) => (
                          <MenuItem key={branch.id} value={branch.id}>
                            {i18n.language === EN_ACCEPT_LANGUAGE ? branch?.nameEn : branch?.nameLa}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {/* <SelectedBranchComponentVoid value={controller.branchValue} onSelectMerchant={controller.handleSelectedBranch} merchantData={controller.branchData} /> */}
                  </Box>
                </Box>
              </Box>
              <Box mb={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <Box
                      sx={{
                        backgroundColor: '#C4EAFF',
                        borderRadius: '16px',
                        p: 4,
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box>
                        <Typography color="#7A4100" sx={{ mb: 1 }}>
                          {t('coupon_page.All coupons')}
                        </Typography>
                        <Typography color="#7A4100" fontWeight="bold" fontSize={32}>
                          {numberFormat(controller.filterDataByBranch?.length)}{' '}
                          {t('coupon_page.Coupon')}
                        </Typography>
                      </Box>
                      <Box>
                        <img
                          src={ALL_PRODUCT_STATISTIC}
                          alt=""
                          style={{ width: 100, height: 100 }}
                        />
                      </Box>
                    </Box>
                  </Grid>
                  {/* <Grid item xs={12} sm={6} md={4}>
                                <Box sx={{ backgroundColor: '#C8FACD', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                    <Box>
                                        <Typography color="#005249" sx={{ mb: 1 }}>Active coupon</Typography>
                                        <Typography color="#005249" fontWeight="bold" fontSize={32}>{numberFormat(39346)} products</Typography>
                                    </Box>
                                    <Box>
                                        <img src={ACTIVE_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                    </Box>
                                </Box>
                            </Grid> */}
                </Grid>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'end', flexWrap: 'wrap', mb: 2, gap: 1 }}>
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{ textTransform: 'none', color: 'white' }}
                  onClick={controller.handleOpenForm}
                >
                  <AddIcon /> &nbsp;&nbsp;{t('coupon_page.Create new coupon')}
                </Button>
              </Box>
              <Box>
                <TabPanelCouponPage
                  value={controller.couponType}
                  onChange={controller.handleTabCouponPage}
                />
              </Box>
              {controller.loadingData ? (
                <LinearProgress />
              ) : (
                <Box>
                  <Box mt={2}>
                    {renderTable}
                    <Divider sx={{ mt: 1, mb: 1 }} />
                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                      <Pagination
                        onChange={controller.handleChangePage}
                        page={controller.currentPage}
                        count={controller.countPagination}
                        color="primary"
                      />
                    </Box>
                  </Box>
                </Box>
              )}
            </>
          )}
          <Popover
            open={Boolean(controller.openMenu)}
            anchorEl={controller.openMenu}
            onClose={controller.handleCloseMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                p: 1,
                width: 140,
                '& .MuiMenuItem-root': {
                  px: 1,
                  typography: 'body2',
                  borderRadius: 0.75,
                },
              },
            }}
          >
            {/* <MenuItem onClick={() => controller.handleOpenEditCoupon()}>
                            <EditIcon />
                            &nbsp;&nbsp;
                            {t('Edit')}
                        </MenuItem> */}

            <MenuItem
              sx={{ color: 'error.main' }}
              onClick={() => controller.handleOpenDeleteForm()}
            >
              <DeleteIcon />
              &nbsp;&nbsp;
              {t('coupon_page.Delete')}
            </MenuItem>
          </Popover>
          <ConfirmDialog
            open={controller.openDeleteForm}
            title={t('coupon_page.Do you want to delete this Coupon')}
            loading={controller.loadingDeleteButton}
            onCancel={controller.handleCloseDeleteForm}
            onConfirm={() => controller.handleDeleteCoupon()}
          />
        </Box>
      )}
    </Box>
  );
};
export default CouponView;
